/**
 *
 * InputMessage
 *
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import DOMPurify from 'dompurify';
import { slideUp } from 'styles/animation';
import isEmail from 'validator/lib/isEmail';
import isMobilePhone from 'validator/lib/isMobilePhone';
import {PUBLIC_DOMAINS} from "../../../common/public-domains-list";
import Select, { components, OptionProps } from 'react-select';
import {MESSAGE_TYPES} from "../../containers/App/constants";

const InputBox = styled.div`
  float: left;
  opacity: 0;
  transform: translateY(10px);
  will-change: transform;
  animation: ${slideUp} 0.4s ease-in-out 0.08s forwards;
  width: calc(100% - 40px);
`;

const InputBoxBody = styled.div`
  position: relative;
  height: inherit;
  box-sizing: unset;
  padding: 10px 0 0;
  background-color: white;
  color: black;
  background: ${p => p.theme.palette.blue5};
  border-radius: 15px;
  margin: 0;
  padding: 10px;
`;

const InputBoxBodyLabel = styled.div`
  margin: 0px 10px 10px;
  font-size: 13px;
  line-height: 20px;
  font-weight: 700;
`;
const InputBoxBodyInputLabel = styled.label`
  position: absolute;
  font-size: 12px;
  line-height: 17px;
  transform: ${p => p.empty ? 'translateY(0px)' : 'translateY(-18px)'};
  will-change: transform;
  color: #495465;
  opacity: 0.5;
  transition: 0.2s all;
`;


const InputBoxBodyInput = styled.input`
  border: none;
    padding: 0;
    background: transparent;
    width: calc(100% - 40px);
    font-size: 14px;
    line-height: 17px;
    color: #495465;
    z-index: 1;
    outline: none;

`;

const InputBoxBodyInputForm = styled.form`
  width: 100%;
  padding: ${p => p.isPadding ? "" : "23px 17px 20px"};
  box-sizing: border-box;
  color: black;
  border-radius: ${p => p.isPadding ? "8px" : "15px"};
  background: white;
  border: 1px solid ${p => p.error ? 'red' : p.bgColor};
  margin: 0;
  display: flex;
  justify-content: space-between;
  & > div {
    ${p => p.isPadding ? "width: 100% !important" : ""}
  }
`;

const InputBoxBodyInputValidate = styled.div`
  position: relative;
  margin-bottom: 10px;
  margin: 0;
  ${p => p.isPickList ? "display: flex" : ""};
`;

const InputBoxBodyInputSubmit = styled.button`
  cursor: pointer;
  background-color: transparent;
  border: none;
  padding: 0;
  &:focus {
    outline: none;
  }
`;

const InputBoxInputSubmit = styled.div`
  cursor: ${p=> p.isDisabled ? "disabled" : "pointer"};
  background-color: transparent;
  border: none;
  padding: 0 4px 0 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:focus {
    outline: none;
  }  
`

const InputBoxBodyInputSubmitIcon = styled.svg`
  height: 16px;
  width: 16px;
`;

const InputBoxBodyInputSubmitSuccessIcon = styled.svg`
  height: 12px;
  width: 15px;
  stroke: ${p => p.bgColor};
  z-index: 0;
`;

const ErrorMessage = styled.div`
  font-size: 10px;
  color: red;
  position: absolute;
  top: 7px;
`;

const OptionHolder = styled.div`
  border-bottom: 1px solid #EDF0F7;
  padding: 10px 8px;
  margin: 0 8px;
  cursor: pointer;
  color: #7A8392;
  &:last-child {
    border: none;
  }
  &:hover{
    color: #0A7EF9;
  }
`

export const IndicatorDiv = styled.div`
  display: flex;
`

export function isDomainBlocked(domain, blockedDomains = null) {

  blockedDomains = blockedDomains ? blockedDomains.split(",").map((item) => {
    return item.trim();
  }):null;
  domain = domain.toLowerCase();

  let isPublicDomain = PUBLIC_DOMAINS.indexOf(domain) !== -1;
  let isBlockedDomain = blockedDomains?blockedDomains.indexOf(domain) !== -1:false;

  return isPublicDomain||isBlockedDomain;
}

  export const InputMessage = ({ message, Language, userSettingColor, processUserResponse }) => {
  const input = message ? (message.input ? message.input : {}) : {};
  const [errorMesssage, setErrorMessage] = useState();
  const [isInputEmpty, setIsInputEmpty] = useState(true);
  const [pickListSelectedValue, setPickListSelectedValue] = useState(null);
  const [inputValue, setInputValue] = useState('');
  const handleSubmit = e => {
    e.preventDefault();

    let val = e.target[input.type].value.trim();
    const clean = DOMPurify.sanitize(val, { ALLOWED_TAGS: [] });
 
    if (val.length < 1) {
      setErrorMessage(Language && Language.InputMessageEnterYourInfoError && Language.InputMessageEnterYourInfoError.toString().replace("{input.text}", input.text));
      return;
    }
    else if (clean !== val) {
      setErrorMessage(Language && Language.InputMessageSanitizeError && Language.InputMessageSanitizeError.toString().replace("{input.text}", input.text));
      return;
    }

    switch(input.key) {
      case 'email':
        if (isEmail(val)) {
          let domain = val.substring(val.lastIndexOf("@") +1);
          let blockedDomains = input.blockedDomains;

          if(!input.validateDomains || !isDomainBlocked(domain, blockedDomains))
          {
            processUserResponse(val, input.type, message, message.input?.uid);
            setErrorMessage(null);
          }
          else setErrorMessage(Language && Language.InputMessageBusinessEmailError);
        } else {
          setErrorMessage(Language && Language.InputMessageValidEmailError);
        }
        break;
      case 'phone':
        if (isMobilePhone(val)) {
          processUserResponse(val, input.key, message, message.input?.uid);
          setErrorMessage(null);
        } else {
          setErrorMessage(Language && Language.InputMessageValidPhoneNumberError);
        }
        break;
      default:
        processUserResponse(val, input.type, message, message.input?.uid);
        setErrorMessage(null);
    }
  };

    const checkboxSelectStyle = {
      control: (base, state) => ({
        ...base,
        opacity: 1,
        height: '62px',
        fontSize: '16px !important;',
        padding: '0',
        borderRadius: "8px",
        border: "none",
        width: "100%",
      }),
      placeholder: (base, state) => {
        return {
          ...base,
          fontSize: '14px',
          color: '#525F76',
        };
      },
      option: (base) => ({
        fontSize: '16px'
      }),
      menu: base => {
        return {
          ...base,
          marginBottom: "20px",
          boxShadow: "0px 4px 8px 1px rgba(0, 0, 0, 0.25)",
          border: "none",
          borderRadius: "10px",
          width: `100%`,
          backgroundColor: "#FFFFFF",
          display: "flex",
        };
      },
      menuList: base => {
        return {
          ...base,
          flex: 1,
        }
      },
      indicatorSeparator: base => {
        return {
          display: 'none',
        }
      },
    };

    const Option = (props) => {
      return (
          <OptionHolder onClick={() => {
            props.selectOption({label: props.label, value: props.value});
          }}>
            <components.Option {...props} />
          </OptionHolder>
      );
    };

    const pickListSendButtonColor = () => {
      if(pickListSelectedValue === null)
        return "#A3AEBF";
      else
        return userSettingColor ? userSettingColor.headerBackgroundColor : null;

    }

    const translateInputFieldLabel = (inputText, Language) => {
      if(Language && Language.InputFieldsText && Language.InputFieldsText[inputText?.toString()?.toLowerCase()]) return Language.InputFieldsText[inputText?.toString()?.toLowerCase()].toString();
      return inputText;
    }

  return (
    <InputBox id="insent-input-message-input-box">
      <InputBoxBody id="insent-input-message-input-box-body">
        <InputBoxBodyLabel id="insent-input-message-input-box-body-label">{translateInputFieldLabel(input.text, Language)}</InputBoxBodyLabel>
        <InputBoxBodyInputValidate id="insent-input-message-input-box-body-input-validate" isPickList={input.type===MESSAGE_TYPES.input.picklist}>
          <InputBoxBodyInputForm
            id="insent-input-message-input-box-body-input-form"
            bgColor={userSettingColor ? userSettingColor.headerBackgroundColor : null}
            textColor={userSettingColor ? userSettingColor.headerTextColor : null}
            onSubmit={handleSubmit}
            isPadding={input.type === MESSAGE_TYPES.input.picklist && !input.disabled}
            error={errorMesssage ? true : false}
          >
            {input.disabled ? (
              <>
                <InputBoxBodyInput id="insent-input-message-input-box-body-input" readOnly value={input.value} />
                <InputBoxBodyInputSubmitSuccessIcon
                  id="insent-input-message-input-box-body-input-submit-success-icon"
                  bgColor={userSettingColor ? userSettingColor.headerBackgroundColor : null}
                >
                  <path
                    d="M1 5.485l5.194 4.706L13.36.874"
                    strokeWidth="2.5"
                    fill="none"
                    fillRule="evenodd"
                  />
                </InputBoxBodyInputSubmitSuccessIcon>
              </>
            ) : (input.type === MESSAGE_TYPES.input.picklist ? (
                <>
                  <Select
                    placeholder={translateInputFieldLabel("Select Field", Language)}
                    styles={checkboxSelectStyle}
                    components={{Option}}
                    onChange={selectedOption =>
                    {
                      setPickListSelectedValue(selectedOption);
                    }}
                    options={input.picklistValues}
                    menuPlacement={'auto'}
                  />
                </>
            ):(
              <>
                  {(errorMesssage && errorMesssage.length) ?
                    (<ErrorMessage>{errorMesssage}</ErrorMessage>) :
                    <InputBoxBodyInputLabel empty={isInputEmpty} htmlFor={input.type}>
                      {Language && Language.InputMessageEnterYourInfo && Language.InputMessageEnterYourInfo.replace("{info}", (input.text && typeof input.text === 'string') ? translateInputFieldLabel(input.text, Language) : 'info')}
                    </InputBoxBodyInputLabel>}
                <InputBoxBodyInput
                  autoFocus
                    name={input.type}
                  autoComplete="off"
                  minLength="1"
                  maxLength="50"
                  value={inputValue}
                  onFocus={(e) => {
                    if (e.target.value.length > 0) {
                      setIsInputEmpty(false);
                    } else {
                      setIsInputEmpty(true);
                    }
                  }}
                    onChange={(e) => {
                      if(input.fieldType === "number"){
                        const regex = /^[0-9\b]+$/;
                        if (e.target.value === '' || regex.test(e.target.value)) {
                          setInputValue(e.target.value);
                        }
                      }
                      else setInputValue(e.target.value);

                      if (e.target.value.length > 0) {
                      setIsInputEmpty(false);
                    } else {
                      setIsInputEmpty(true);
                    }
                  }}
                />
                <InputBoxBodyInputSubmit>
                  <InputBoxBodyInputSubmitIcon
                      id="insent-input-box-bode-input-submit-icon"
                    bgColor={userSettingColor ? userSettingColor.headerBackgroundColor : null}
                  >
                    <path d="M1.21644 0.0924218C0.664925 -0.185081 0 0.195829 0 0.788806V4.00309V5.57896V5.99101C0 6.44843 0.360638 6.83313 0.838516 6.88558L7.65962 7.63393C8.10814 7.68312 8.10814 8.30248 7.65962 8.3517L0.838516 9.10005C0.360638 9.15247 0 9.53721 0 9.99462V12.0076V13.5834V15.328C0 15.7445 0.354561 16.0346 0.789781 15.9871C1.22599 15.9394 -0.465961 16.7401 15.5278 8.6892C16.1147 8.39365 16.115 7.59199 15.5278 7.2964L1.21644 0.0924218Z" fill={userSettingColor ? userSettingColor.headerBackgroundColor : null} />
                  </InputBoxBodyInputSubmitIcon>
                </InputBoxBodyInputSubmit>
              </>
            ))}
          </InputBoxBodyInputForm>
          {input.type === MESSAGE_TYPES.input.picklist && !input.disabled && (
            <InputBoxInputSubmit
                isDisabled={pickListSelectedValue === null}
                onClick={e => {
                  e.preventDefault();
                  if(pickListSelectedValue === null) return;
                  processUserResponse(pickListSelectedValue, input.type, message);
                }}
            >
              <InputBoxBodyInputSubmitIcon
                  id="insent-input-box-bode-input-submit-icon"
                  bgColor={userSettingColor ? userSettingColor.headerBackgroundColor : null}
              >
                <path d="M1.21644 0.0924218C0.664925 -0.185081 0 0.195829 0 0.788806V4.00309V5.57896V5.99101C0 6.44843 0.360638 6.83313 0.838516 6.88558L7.65962 7.63393C8.10814 7.68312 8.10814 8.30248 7.65962 8.3517L0.838516 9.10005C0.360638 9.15247 0 9.53721 0 9.99462V12.0076V13.5834V15.328C0 15.7445 0.354561 16.0346 0.789781 15.9871C1.22599 15.9394 -0.465961 16.7401 15.5278 8.6892C16.1147 8.39365 16.115 7.59199 15.5278 7.2964L1.21644 0.0924218Z" fill={pickListSendButtonColor()} />
              </InputBoxBodyInputSubmitIcon>
            </InputBoxInputSubmit>
          )}
        </InputBoxBodyInputValidate>
      </InputBoxBody>
    </InputBox>
  );
};

InputMessage.propTypes = {
  message: PropTypes.object,
  processUserResponse: PropTypes.func,
};

export default InputMessage;
